import { Injectable, Injector } from '@angular/core';
import { PracaExibicao } from '../../shared-models/model/praca-exibicao.model';
import { BaseResourceService } from './base-resource.service';

@Injectable({
    providedIn: 'root'
})
export class PracaExibicaoResourceService extends BaseResourceService<PracaExibicao> {

    constructor(protected injector: Injector) {
        super('/pracas', injector, PracaExibicao.fromJson);
    }
}
